<template>
    <label :for="id" :class="blueClass != undefined ? 'blueBg' : ''">
        <span>{{ label }}</span>
        <input v-if="type != 'select'" :type="type" :id="id" :value="modelRef" @input="inputFunc"
            :maxlength="max != undefined ? max : 2000" :min="min != undefined ? 0 : false"
            :disabled="editable != undefined && editable == false" />
        <SearchableSelect v-else
            :id="id"
            :modelRef="modelRef"
            :optList="optList"
            :optValue="optValue"
            :optDisplay="optDisplay"
            :useIdx="useIdx"
            :disabled="editable != undefined && editable == false"
            :inputFunc="inputFunc"
            placeholder="Selecione uma opção"
            extraClass="rta-custom-select"
        />
    </label>
</template>

<script>
import SearchableSelect from "./SearchableSelect.vue";
export default {
    name: "CustominputRta",
    components: { SearchableSelect },
    props: ["id", "type", "label", "modelRef", "editable", "min", "max", "inputFunc", "blueClass", 'optList', 'optValue', 'optDisplay', 'useIdx']
}
</script>

<style scoped>
label {
    width: 100%;
    position: relative;
}

label span {
    position: absolute;
    top: -.7rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.7rem;
    color: #FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
    z-index: 2;
}

label input {
    width: 100%;
    height: 30px;
    padding: 6px;
    border: 1px solid #C7C7C7 !important;
    border-radius: 0.2rem;
    font-size: 0.85rem;
}

.rta-search-select {
    height: 100%;
}

.rta-custom-select {
    min-height: 30px;
    height: 30px;
}

.blueBg span {
    color: #008787 !important;
}

.defaultopt{
    color: #999999;
}
</style>

